import _ from 'lodash';
import { parse } from 'querystring';
import { log } from './log';

export type Route = {
  /**
   * Any valid URL path
   */
  path?: string;
  /**
   * A React component to render only when the location matches.
   */
  component?: string | (() => any);
  wrappers?: string[];
  /**
   * navigate to a new location
   */
  redirect?: string;
  /**
   * When true, the active class/style will only be applied if the location is matched exactly.
   */
  exact?: boolean;
  routes?: Route[];
  [k: string]: any;
};

export const isUrl = (path: string): boolean =>
  /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/.test(
    path,
  );

export const isAntDesignPro = (): boolean => {
  if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
    return true;
  }
  return window.location.hostname === 'preview.pro.ant.design';
};

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env;
  if (NODE_ENV === 'development') {
    return true;
  }
  return isAntDesignPro();
};

export const getPageQuery = () => {
  const { href } = window.location;
  const qsIndex = href.indexOf('?');
  const sharpIndex = href.indexOf('#');

  if (qsIndex !== -1) {
    if (qsIndex > sharpIndex) {
      return parse(href.split('?')[1]!);
    }

    return parse(href.slice(qsIndex + 1, sharpIndex));
  }

  return {};
};
export async function wait(time: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('');
    }, time);
  });
}

export const replaceGoto = () => {
  const urlParams = new URL(window.location.href);
  const params = getPageQuery();
  let { redirect } = params as { redirect: string };
  if (redirect) {
    const redirectUrlParams = new URL(redirect);
    if (redirectUrlParams.origin === urlParams.origin) {
      redirect = redirect.substr(urlParams.origin.length);
      if (redirect.match(/^\/.*#/)) {
        redirect = redirect.substr(redirect.indexOf('#'));
      }
    } else {
      window.location.href = '/';
      return;
    }
  }
  window.location.href = urlParams.href.split(urlParams.pathname)[0] + (redirect || '/');
};

function add0(m: number) {
  return m < 10 ? `0${m}` : m;
}

// 时间戳转化成时间格式
export function timeFormat(timestamp: any) {
  // timestamp是整数，否则要parseInt转换,不会出现少个0的情况
  const time = new Date(timestamp);
  const year = time.getFullYear();
  const month = time.getMonth() + 1;
  const date = time.getDate();
  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();
  return `${year}/${add0(month)}/${add0(date)} ${add0(hours)}:${add0(minutes)}:${add0(seconds)}`;
}

export function findParentRoute(route: Route, path: string) {
  const pathNames = _.trim(path, '/').split('/');
  const parentPath = pathNames[0];
  const proute = _.find(route.routes, { name: parentPath });
  const nroute = proute || route;
  return _.find(nroute.routes, { path }) ? null : nroute;
}

export type Optional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export function bulkSetProperties<T>(
  object: T,
  data: Partial<T> | Readonly<T> | Pick<T, keyof T> | Omit<T, keyof T> | Optional<T, keyof T>,
) {
  if (data) {
    // eslint-disable-next-line array-callback-return
    (Object.entries(data) as [keyof T, never][]).map(([key, value]) => {
      object[key] = value;
    });
  }
}

export function parseJson(str: string) {
  try {
    return JSON.parse(str);
  } catch (error) {
    log.error(error);
  }
}
